"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PaginationTable_1 = require("../PaginationTable");
var react_1 = require("react");
require("../../styles/CustomerListPage.css");
require("../../styles/UserPage.css");
var msal_react_1 = require("@azure/msal-react");
var msal_browser_1 = require("@azure/msal-browser");
var authConfig_1 = require("../../authConfig");
var user_1 = require("../../api/user");
var CustomerAddUser_1 = require("./modals/CustomerAddUser");
var CustomerUserPage = function (props) {
    var authRequest = __assign({}, authConfig_1.loginRequest);
    var inProgress = msal_react_1.useMsal().inProgress;
    var _a = react_1.useState(new Array()), list = _a[0], setList = _a[1];
    var handleEdit = function (row) {
        console.log(row);
    };
    var handleDelete = function (row) { };
    var customerListColumns = [
        {
            Header: 'Profile Pic',
            accessor: 'profilePic',
            Cell: function (row) {
                return React.createElement("div", { id: "Customer-Name" },
                    React.createElement("div", { id: "Logo" },
                        React.createElement("img", { className: "customer-pic", src: row.value ? row.value : './images/customer-icon.png' })));
            }
        },
        {
            Header: 'Customer Name',
            accessor: 'name',
            //Cell: (row: any) =>
            //    <div id="Customer-Name">
            //        <div id="Logo">
            //            <img className="logo-image" src={getPicByKeyNum(row.value)} />
            //        </div>
            //        <div id="CustomerName-Text">
            //            <td id="CustName-Text">{getNameByKeyNum(row.value)}</td>
            //        </div>
            //    </div>
        },
        {
            Header: 'Email',
            accessor: 'email'
        },
        {
            Header: 'Position',
            accessor: 'position'
        }
    ];
    var getPicByKeyNum = function (num) {
        return list && list.length > 0 && num <= (list.length - 1) ? list[num].profilepic : "#";
    };
    var getNameByKeyNum = function (num) {
        return list && list.length > 0 && num <= (list.length - 1) ? list[num].name : "";
    };
    var CustomerAddUserCallBack = function () {
        user_1.fetchUsersByCompanyId(props.id).then(function (data) {
            console.log(data);
            setList(data.list);
        }).catch(console.error);
    };
    var onLoad = function () {
        //RequestProfileData();
        if (list.length === 0) {
            user_1.fetchUsersByCompanyId(props.id).then(function (data) {
                console.log(data);
                setList(data.list);
                //return {
                //    id: item.id,
                //    key: item.displayName,
                //    name: item.displayName,
                //    position: item.jobTitle,
                //    email: item.mail,
                //    createdAt: item.createdDateTime,
                //    profilepic: "#"
                //};
            }).catch(console.error);
        }
    };
    react_1.useEffect(function () {
        if (list.length === 0 && inProgress === msal_browser_1.InteractionStatus.None)
            onLoad();
    }, [inProgress, list, setList]);
    return (React.createElement(React.Fragment, null,
        React.createElement(msal_react_1.MsalAuthenticationTemplate, { interactionType: msal_browser_1.InteractionType.Redirect, authenticationRequest: authRequest },
            React.createElement("div", { className: "card-header" },
                React.createElement(CustomerAddUser_1.default, { companyId: props.id, modalCallback: CustomerAddUserCallBack })),
            React.createElement("div", { className: "tableContainer borderlessContainer" }, list ? React.createElement(PaginationTable_1.PaginationTable, { columns: customerListColumns, data: list }) : React.createElement(React.Fragment, null, "Loading...")))));
};
exports.default = CustomerUserPage;
//# sourceMappingURL=CustomerUserPage.js.map